// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import { HelmetProvider } from 'E:/web/molong/reset/frontend/gatherstar-admin/node_modules/.pnpm/@umijs+renderer-react@4.6.1_50b428cdea9a853bd4feb7eb680fcb88/node_modules/@umijs/renderer-react';
import { context } from './helmetContext';

export const innerProvider = (container) => {
  return React.createElement(HelmetProvider, { context }, container);
}
